import { render, staticRenderFns } from "./ModalActivities.vue?vue&type=template&id=aee2e724&"
import script from "./ModalActivities.vue?vue&type=script&lang=js&"
export * from "./ModalActivities.vue?vue&type=script&lang=js&"
import style0 from "./ModalActivities.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports